<template>
    <div
        class="tw-h-9 tw-rounded-full tw-bg-gray-300">
        <slot></slot>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
